import React from 'react';
import { withRouter } from 'react-router-dom';
import {Button,Row,Card,Spin,Form,DatePicker} from 'antd';
import {getBundleById,postpontBundle} from 'actions/bundle';
import BaseContent from 'components/BaseContent';
import BaseModal from 'components/BaseModal';
import style from './index.less';
import {BUNDLE_ID_STATE_MAP,AUTH_TYPE,renderStateText,SDK} from 'utils/bundleConst';
import moment from 'moment';
const FormItem = Form.Item;
class BundleView extends React.Component {

    constructor(props){
        super(props);
        const _defaultDate = moment().add(1,'day');
        this.state = {
            info: {},
            showPostpone:false,
            loading:true,
            date:_defaultDate
        };
        this.id = props.match.params.id;
    }

    componentDidMount(){
        //获取bundle详情
        getBundleById(this.id).then(res=>{
            this.setState({info:res.data,loading:false});
        }).catch((res)=>{
            const msg = res.data.msg || res.error.msg;
            BaseModal.error({
                title: 'Error',
                content: msg,
                onOk:()=>{
                    this.props.history.push('/pages/app/bundle');
                }
            });
        });
    }
    showPostpone=()=>{
        this.setState({showPostpone:true});
    }
    onPostponeCancel = ()=>{
        this.setState({showPostpone:false});
    }

    onPostponeOk = ()=>{
        const params = {
            extension_expire_date:this.state.date.format('YYYY-MM-DD'),
            extension_status:1
        };
        postpontBundle(this.id,params).then(()=>{
            const _info = {...this.state.info,...params};
            this.setState({info:_info,showPostpone:false});
        });
    }

    disabledDate = (date)=>{
        if(date){
            return date.isBefore(moment());
        }

    }

    onDateChange = (date, dateString)=>{
        this.setState({date});
    }

    renderDefer(){
        const {info,showPostpone} = this.state;
        if(!showPostpone){
            if(info.auth_type === AUTH_TYPE.online.value){
                switch (info.extension_status) {
                    case 1:
                        return <span className={style.deferText}>Has applied for extension to:{ info.extension_expire_date }</span>;
                    default:
                        return <Button type="primary" onClick={this.showPostpone}  style={{marginLeft:24}}>Postpone</Button>;
                }
            }
        }else{
            return (
                <div className={style.postpone}>
                    |<span className={style.postponeLine}>Postponed to:</span> <DatePicker onChange={this.onDateChange} value={this.state.date} allowClear={false} disabledDate={this.disabledDate} showToday={false} dropdownClassName={style.datapicker}/> <Button type="primary" onClick={this.onPostponeOk}  style={{marginLeft:24}}>Ok</Button><Button onClick={this.onPostponeCancel} style={{marginLeft:24}}>Cancel</Button>
                </div>
            );
        }
        return null;
    }

    render() {
        const {info} = this.state;
        const formItemLayout = {
            labelCol: {
                span:5,
                style:{width:'115px',display: 'inline-block'}

            },
            wrapperCol: {
                span:19,
                style:{display: 'inline-block'}
            },
        };
        const footer = (
            <Row>
                {info.state === BUNDLE_ID_STATE_MAP.reject?<Button type="primary" style={{width: 120,marginLeft:60}} onClick={()=> this.props.history.push('/pages/app/bundle/'+this.id+'/edit')}>Recreate</Button>:null}
                {<Button style={{width: 120,marginLeft:60}} onClick={()=> this.props.history.push('/pages/app/bundle')}>Back</Button>}
            </Row>
        );

        let download;
        if (info.auth_type === 0) {
            if (info.state === 3 || info.state === 2) {
                download = 'SDK下载文件准备中...';
            } else if (info.state === 4) {
                download = <Button type="primary"><a href={info.url} >Download all SDK</a></Button>;
            }
        } else if (info.auth_type === 2) {
            if (info.url) {
                download = <Button type="primary"><a href={info.url} >Download all SDK</a></Button>;
            }
        }

        return (
            <Spin spinning={this.state.loading}>
                <BaseContent style={{minHeight: 0}} footer={footer}>

                    <Card title="Check the Bundle ID" bordered={false} style={{color:'#515666'}}>
                        <Form>
                            <FormItem
                                label="BundleID"
                                {...formItemLayout}
                            >
                                <div className={style.content}>{info.bundle_id}</div>
                            </FormItem>
                            <FormItem
                                label="Platform"
                                {...formItemLayout}
                            >
                                <div className={style.content}>{info.platform}</div>
                            </FormItem>
                            {info.state === BUNDLE_ID_STATE_MAP.done ?
                                <FormItem
                                    label="Validity date"
                                    {...formItemLayout}
                                >
                                    <div className={style.content}>
                                        {this.state.info.expired_time}
                                        {this.renderDefer()}
                                    </div>
                                </FormItem>:null
                            }
                            <FormItem
                                label="State"
                                {...formItemLayout}
                            >
                                <div className={style.content}>
                                    <h1>{renderStateText(this.state.info)}</h1>
                                    {/* 延期申请驳回原因 */}
                                    {info.extension_status === -1?<p>{'Refusal reason:'+info.extension_reject_reason}</p>:null}
                                    {/* 绑定申请驳回原因 */}
                                    {info.state === BUNDLE_ID_STATE_MAP.reject ?<p>{'Refusal reason:'+info.reject_reason}</p>:null}
                                </div>
                            </FormItem>
                            <FormItem
                                label="SDK"
                                {...formItemLayout}
                            >
                                <div className={style.content}>
                                    {download}
                                    {SDK.map(item=>{
                                        if(info.permissions && info.permissions.includes(item.value)){
                                            return <div>
                                                <h1>{item.label}</h1>
                                                <p dangerouslySetInnerHTML={{__html:item.desc}}></p>
                                            </div>;
                                        }
                                        return null;
                                    })}
                                </div>
                            </FormItem>
                        </Form>
                    </Card>
                </BaseContent>
            </Spin>
        );
    }
}

export default withRouter(BundleView);




// WEBPACK FOOTER //
// ./src/pages/BundleView/index.js